module.exports = __webpack_public_path__ + "img/Instagram.e51b6589.svg";